export default "__VITE_ASSET__5aV3MMKq__"